<template>
  <div>
    <div class="row">
      <div class="col-md-8 col-sm-12 h-100">
        <Breadcrumb :page="page" />
      </div>
      <div
        v-if="hasPermission"
        class="col-md-4 col-sm-12 pr-0 text-right mt-4 mb-3 mb-md-0 mb-sm-3"
      >
        <router-link to="/pei/affirmativeletterhistorysearch">
          <ActionButton
            variant="outline-success mr-3"
            i="fas fa-arrow-circle-left"
          >
            Regresar
          </ActionButton>
        </router-link>

        <ActionButton
          v-if="formMode === 1"
          variant="outline-success mr-3"
          i="fas fa-file-import"
          type="submit"
          @click="showConfirmSubmit"
        >
          Someter
        </ActionButton>

        <ActionButton
          v-if="formMode === 1"
          variant="success"
          i="fas fa-save"
          @click="saveAffirmativeLetter"
        >
          Guardar
        </ActionButton>
      </div>
      <div class="dropdown-divider mt-0 pb-2 w-100" />
    </div>

    <div class="row">
      <ValidationObserver ref="formValidator" class="w-100">
        <form class="needs-validation" validate>
          <div class="col-12 pr-0">
            <div class="tab-content">
              <div class="main-content">
                <SectionTitle
                  :content="'Información General'"
                  :has-line="true"
                  class="mb-4"
                />
                <div class="pl-3 mb-4">
                  <div class="row">
                    <div class="col-md-6 col-sm-12">
                      <div class="row mb-4">
                        <div class="col-md-2 col-sm-12 mt-2">
                          <span>
                            <b>Año Académico:</b>
                          </span>
                        </div>
                        <div class="col-md-4 col-sm-12">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="SelectAcademicYears"
                            rules="required"
                          >
                            <CustomDropDown
                              v-model="model.academicYearShort"
                              placeholder="Seleccionar"
                              fieldkey="id"
                              required
                              fieldname="description"
                              :options="academicYears"
                              :disabled="formMode === 2"
                              :error="errors[0]"
                              :custom-error-msg="
                                errorMsgs['SelectAcademicYears']
                              "
                            />
                          </ValidationProvider>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6 col-sm-12">
                      <div class="row">
                        <div class="col-md-2 col-sm-12 mt-4">
                          <span>
                            <b>Fecha Firma:</b>
                          </span>
                        </div>
                        <div
                          class="col-md-10 col-sm-12 text-left mt-0 mt-md-4 mt-sm-0"
                        >
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="FechaFirma"
                            rules="required"
                          >
                            <CustomDatePicker
                              v-model="model.signatureDate"
                              class="w-35"
                              required
                              format="dd/MMM./yyyy"
                              :disabled="formMode === 2"
                              :max-date="disabledDatesFrom"
                              :error="errors[0]"
                              :custom-error-msg="errorMsgs['FechaFirma']"
                            />
                          </ValidationProvider>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row mt-3 mt-md-0 mt-sm-5">
                    <div class="col">
                      <div class="row">
                        <div class="col-md-2 col-sm-12 mt-n3">
                          <span>
                            <b>Creación:</b>
                          </span>
                        </div>
                        <div class="col-md-10 col-sm-12">
                          <div class="text-left info-detail">
                            <span class="d-block">{{ model.createdDate }}</span>
                            <span class="d-block">
                              {{ model.createdByDescription }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col">
                      <div class="row">
                        <div class="col-md-2 col-sm-12 mt-n3">
                          <span>
                            <b>Sometida:</b>
                          </span>
                        </div>
                        <div class="col-md-10 col-sm-12">
                          <div class="text-left info-detail">
                            <span class="d-block">
                              {{
                                model.submissionDate
                                  ? model.submissionDate
                                  : '-'
                              }}
                            </span>
                            <span class="d-block">
                              {{
                                model.submittedByDescription
                                  ? model.submittedByDescription
                                  : '-'
                              }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mt-5 add-container">
                  <SectionTitle
                    :content="'Servicios Carta Afirmativa'"
                    :has-line="true"
                    class="mb-1"
                  />

                  <ServicesAffirmativeLetter
                    :services="model.services"
                    :form-mode="formMode"
                    @addService="onAddService"
                  />
                  <Error
                    v-if="
                      (!serviceValid || model.services.length == 0) &&
                        isSubmitted
                    "
                    variant="no-border"
                    message="Favor de añadir los servicios a la carta afirmativa. (190707)"
                  />
                </div>

                <div v-if="model.documents.length >= 0" class="mt-5">
                  <SectionTitle
                    content="Documento"
                    :has-line="true"
                    class="mb-1 mt-4"
                  />
                  <div class="container-table-striped w-100">
                    <div class="table-hover">
                      <table
                        id="documentsTable"
                        class="table content-table-striped table-h"
                      >
                        <thead>
                          <tr class="row global-thead-dark thead-property">
                            <th class="col-4 text-left bold">
                              Nombre Archivo
                            </th>
                            <th class="col-4 text-left bold">
                              Tipo de Documento
                            </th>
                            <th class="col-4 bold" />
                          </tr>
                        </thead>
                        <DocumentRow
                          :obj-doc="model.documents[0]"
                          :doc="selectedDocument"
                          :form-mode="formMode"
                          @addFile="addFileHandler"
                        />
                      </table>
                    </div>
                  </div>
                  <Error
                    v-if="!fileValid && isSubmitted"
                    variant="no-border"
                    message="Favor de seleccionar un documento (0227)"
                  />
                </div>
              </div>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import store from '@/store/index';
import Breadcrumb from '@/components/common/page/TitleBreadcrumb';
import { SectionTitle } from '@/components/pei/shared';
import CustomDatePicker from '@/components/common/CustomDatePicker';
import { DocumentRow, ServicesAffirmativeLetter } from './components';
import ActionButton from '@/components/common/ActionButton';
import CustomDropDown from '@/components/common/CustomDropDown';
import objectToFormData from 'object-to-formdata';
import moment from 'moment';
import resourcesService from '@/services/resources.js';
import Error from '@/components/common/Error';
import alert from '@/mixin/alert.mixin';
import loading from '@/mixin/loading.mixin';

export default {
  name: 'AffirmativeLetterHistoryAdd',
  mixins: [alert, loading],
  data() {
    return {
      selectedDocument: null,
      model: {
        peiAffirmativeLetterStatusId: 1,
        services: [],
        documents: [
          {
            affirmativeLetterDocumentId: null,
            documentTitle: null,
            description: 'Carta Afirmativa',
            attachmentId: null,
            peiAffirmativeLetterDocumentTypeId: 0,
            documentTypeId: 0,
            binary: null,
            fileName: null,
            requerido: 'True',
            documentId: null,
            id: 1,
          },
        ],
      },
      formMode: 1,
      serviceValid: true,
      fileValid: false,
      peiAffirmativeLetterId: store.getters.SelectedPeiAffirmativeLetter,
      isInsertMode: false,
      isSubmitted: false,
      errorMsgs: {
        FechaFirma:
          'Favor de entrar la fecha de firmado de la Carta Afirmativa. (190703)',
        SelectAcademicYears: 'Favor de seleccionar el Año Académico.  (190701)',
      },
      errorMessage: '',
      academicYears: [],
      academicYearId: null,
      page: {
        icon: 'fas fa-file-alt',
        title: 'Carta Afirmativa',
        routes: ['PEI', 'Carta Afirmativa'],
      },
      disabledDatesFrom: new Date(),
      resources: [],
    };
  },
  components: {
    Breadcrumb,
    SectionTitle,
    CustomDatePicker,
    DocumentRow,
    ActionButton,
    ValidationProvider,
    CustomDropDown,
    ValidationObserver,
    ServicesAffirmativeLetter,
    Error,
  },
  methods: {
    onAddService(isValid) {
      this.serviceValid = this.model.services.length > 0 && isValid;
    },
    async saveAffirmativeLetter() {
      const self = this;
      self.isSubmitted = true;
      const isValid = await self.$refs.formValidator.validate();
      self.fileValid =
        self.model.documents[0] && self.model.documents[0].binary != null;

      let servicesValid = self.serviceValid && self.model.services.length > 0;

      if (isValid && servicesValid && self.fileValid) {
        self.model.academicYearId = self.model.academicYearShort.id;

        let formData = objectToFormData(self.model, { indices: true });
        if (this.documentChanged) {
          formData.append(`documents`, self.model.documents[0].binary);
        }

        if (self.peiAffirmativeLetterId == null) {
          await this.createAffirmativeLetters(formData);
        } else {
          await this.updateAffirmativeLetters(formData);
        }
      }
    },
    // Request to create affirmative letter.
    async createAffirmativeLetters(formData) {
      const self = this;

      let promise = await new Promise((resolve) => {
        self
          .$ApiPost('/api/affirmativeLetters/Create', formData)
          .then((res) => {
            self.peiAffirmativeLetterId = res.data.peiAffirmativeLetterId;
            self.$router.push(
              `/pei/affirmativeletterhistoryview/${self.peiAffirmativeLetterId}`
            );
            self.fetchPeiAffirmativeLetter();

            resolve(res.data);

            self.ShowToast(
              self.resources['R03200110'],
              self.resources['R03200109'],
              'success'
            );
          })
          .catch(function(err) {
            self.showToastError(err);
          });
      });

      return promise;
    },
    // Request to update affirmative letter.
    async updateAffirmativeLetters(formData) {
      const self = this;
      self.ShowWait();
      let promise = await new Promise((resolve) => {
        self
          .$ApiPut(
            `/api/affirmativeLetters/${self.peiAffirmativeLetterId}`,
            formData
          )
          .then((res) => {
            resolve(res.data);

            self.ShowToast(
              self.resources['R03200110'],
              self.resources['R03200109'],
              'success'
            );
          })
          .catch(function(err) {
            self.showToastError(err);
          });
      });
      return promise;
    },
    async fetchAcademicYear() {
      await this.$ApiGet('/api/academicyears/getcurrentandnextacademicyears')
        .then((res) => {
          this.academicYears = res.data ? res.data : [];
          if (this.peiAffirmativeLetterId) {
            this.fetchPeiAffirmativeLetter();
          }
        })
        .catch((err) => {
          this.response = err;
        });
    },
    async fetchPeiAffirmativeLetter() {
      let self = this;

      await self
        .$ApiGet(`/api/affirmativeletters/${self.peiAffirmativeLetterId}`)
        .then((res) => {
          res.data.createdDate = res.data.createdDate
            ? moment(res.data.createdDate).format('DD / MMM. / YYYY')
            : null;
          res.data.submissionDate = res.data.submissionDate
            ? moment(res.data.submissionDate).format('DD / MMM. / YYYY')
            : null;
          self.model = res.data;
          self.model.signatureDate = new Date(res.data.signatureDate);
          self.model.documents.forEach((doc) => (doc.added = true));

          self.services = self.model.services;
          self.formMode = self.model.peiAffirmativeLetterStatusId;
        })
        .catch((err) => {
          self.showToastError(err);
        });
    },
    fetchData() {
      this.peiAffirmativeLetterId =
        this.peiAffirmativeLetterId == null
          ? this.$route.params.peiAffirmativeLetterId
          : this.peiAffirmativeLetterId;
    },
    submitData() {
      let self = this;

      self.model.academicYearId = self.model.academicYearShort.id;

      let formData = objectToFormData(self.model, { indices: true });
      if (this.documentChanged) {
        formData.append(`documents`, self.model.documents[0].binary);
      }

      let peiAffirmativeLetterId =
        self.peiAffirmativeLetterId != null
          ? `${self.peiAffirmativeLetterId}`
          : '';
      self
        .$ApiPost(
          `/api/affirmativeLetters/Submit/${peiAffirmativeLetterId}`,
          formData
        )
        .then((res) => {
          self.peiAffirmativeLetterId = res.data.peiAffirmativeLetterId;
          self.$router.push(
            `/pei/affirmativeletterhistoryview/${self.peiAffirmativeLetterId}`
          );
          self.fetchPeiAffirmativeLetter();
          self.formMode = res.data.peiAffirmativeLetterStatusId;

          self.ShowToast(
            self.resources['R03200110'],
            self.resources['R03200149'],
            'success'
          );
        })
        .catch((err) => {
          self.showToastError(err);
        });
    },
    async showConfirmSubmit() {
      const isValid = await this.$refs.formValidator.validate();
      this.isSubmitted = true;

      let servicesValid = this.serviceValid && this.model.services.length > 0;
      this.fileValid =
        this.model.documents[0] && this.model.documents[0].binary != null;

      if (isValid && servicesValid && this.fileValid) {
        let question = this.resources['190712'];
        let alertResponse = await this.ShowCancelModal(
          'Atención',
          question,
          'Sí',
          'No'
        );

        if (alertResponse) {
          this.submitData();
        }
      }
    },
    addFileHandler(doc) {
      this.documentChanged = true;
      this.fileValid = doc != null;
      if (this.model.documents[0]) {
        this.model.documents[0].binary = doc;
        this.model.documents[0].fileName = doc ? doc.name : null;
      } else if (doc) {
        let d = {
          affirmativeLetterDocumentId: null,
          documentTitle: null,
          description: 'Carta Afirmativa',
          attachmentId: null,
          peiAffirmativeLetterDocumentTypeId: 0,
          documentTypeId: 0,
          binary: doc,
          fileName: doc ? doc.name : null,
          requerido: 'True',
          documentId: null,
          id: 1,
        };
        this.model.documents.push(d);
      }
      this.selectedDocument = doc;
    },
    async loadResources() {
      this.resources = await resourcesService.LoadValidationMessages([
        '190712',
        'R03200108',
        'R03200109',
        'R03200110',
        'R03200149',
      ]);
    },
    // Calculate error based on exception.
    showToastError(err) {
      if (err && err.response && err.response.data) {
        this.ShowToast('Alerta', err.response.data.message, 'error');
      } else {
        this.ShowToast('Error', err.message, 'error');
      }
    },
  },
  computed: {
    hasPermission() {
      return store.getters.HasPermission('affirmativeletter.create');
    },
    hasServices() {
      return this.model.services.length > 0 && !this.isInsertMode;
    },
    academicYear() {
      return this.model.academicYearShort;
    },
  },
  async mounted() {
    await this.loadResources();
    this.fetchData();
    await this.fetchAcademicYear();
    //   this.setFormModeWithUrl();
  },
};
</script>

<style scoped>
.btn-succes-outline {
  height: 38px;
  border: 1px solid #2db782 !important;
  color: #2db782;
}
.btn-succes-outline:hover {
  background: #2db782;
  border: 1px solid #2db782;
  color: #fff;
}
.btn.btn-green.success:hover {
  background: #2db782;
  color: #212529;
  text-decoration: none;
}
.thead-property {
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 5px 5px 0px 0px;
}
.info-title p {
  margin-top: -40px;
  margin-bottom: 20px;
  text-align: left;
  font: Bold 14px/17px Lato;
  letter-spacing: 0;
  color: #727272;
  opacity: 1;
}
.main-content {
  margin: 0px;
  padding: 0px;
}
.add-container {
  margin-bottom: 100px !important;
}
.info-detail {
  letter-spacing: 0;
  color: #11291b;
  opacity: 1;
  font-family: 'Lato';
  font-size: 16px;
  font-weight: 400;
}
</style>
